module.exports = __webpack_public_path__ + "img/risk_management_and_internal.0ac79fe5.jpg";